import { render, staticRenderFns } from "./sys-role-add-or-update.vue?vue&type=template&id=70fde818&"
import script from "./sys-role-add-or-update.vue?vue&type=script&lang=js&"
export * from "./sys-role-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./sys-role-add-or-update.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports